import {extendTheme} from '@chakra-ui/react'

// Global styles
import globalStyles from './components/global/globalStyles'
import Swiper from './components/global/swiper'
import SwiperNavigation from './components/global/swiper-navigation'
import SwiperScrollbar from './components/global/swiper-scrollbar'
import SwiperPagination from './components/global/swiper-pagination'
// Foundations
import themeBreakpoints from './foundations/breakpoints'
import textStyles from './foundations/textStyles'
import themeSpacing from './foundations/spacing'
import themeColors from './foundations/colors'
import themeFonts from './foundations/fonts'
import themeSizes from './foundations/sizes'
import borderRadius from './foundations/borderRadius'
// Components
import buttons from './components/button'
import container from './components/container'
import breadcrumb from './components/breadcrumb'
import form from './components/form'
import input from './components/input'
import select from './components/select'
import radio from './components/radio'
import tag from './components/tag'
import checkbox from './components/checkbox'
import accordion from './components/accordion'
import drawer from './components/drawer'
import modal from './components/modal'
import tabs from './components/tabs'
import link from './components/link'
import popover from './components/popover'
// Custom components
// .Atoms
import chips from './components/custom/atoms/chips'
import loader from './components/custom/atoms/loader'
import menuButton from './components/custom/atoms/menu-button'
import price from './components/custom/atoms/price'
import darkOverlay from './components/custom/atoms/dark-overlay'
import spacer from './components/custom/atoms/spacer'
import colorCirle from './components/custom/atoms/color-circle'
// .Molecules
import newsletterInput from './components/custom/molecules/newsletter-input'
import headerLink from './components/custom/molecules/header-link'
import menuItem from './components/custom/molecules/menu-item'
import headline from './components/custom/molecules/headline'
import filterButton from './components/custom/molecules/filter-button'
import sortByWrapper from './components/custom/molecules/sort-by-wrapper'
import bannerHeader from './components/custom/molecules/banner-header'
import cardPhotoVideo from './components/custom/molecules/card-photo-video'
import productTile from './components/custom/molecules/product-tile/product-tile'
import gridLayoutControls from './components/custom/molecules/grid-layout-controls'
import pagination from './components/custom/molecules/pagination'
import toast from './components/custom/molecules/toast'
import quantitySelector from './components/custom/molecules/quantity-selector'
import alertMessage from './components/custom/molecules/alert-message'
import crossCategoryNavigation from './components/custom/molecules/cross-category-navigaton'
import ctaButton from './components/custom/molecules/cta-button'
import scrollDownButton from './components/custom/molecules/scroll-down-button'
// .Organisms
import productsSwiper from './components/custom/organisms/products-swiper'
import footer from './components/custom/organisms/footer/footer'
import heroBanner from './components/custom/organisms/hero-banner/hero-banner'
import header from './components/custom/organisms/header/header'
import doubleSame from './components/custom/organisms/double-same/double-same'
import refinementsGroup from './components/custom/organisms/refinements-group'
import productListing from './components/custom/organisms/product-listing/product-listing'
import twoThirdOneThird from './components/custom/organisms/two-third-one-third'
import filtersList from './components/custom/organisms/filters-list'
import selectedRefinements from './components/custom/organisms/selected-refinements'
import wishlistOrganism from './components/custom/organisms/wishlist/wishlist'
import stickyBanner from './components/custom/organisms/sticky-banner'
import editorialWidget from './components/custom/organisms/widget/widget'
import wallMixed from './components/custom/organisms/wall-mixed/wallMixed'
import mouseover from './components/custom/organisms/mouseover/mouseover'
import titleTextCta from './components/custom/organisms/title-text-cta/titleTextCta'
import bannerHalf from './components/custom/organisms/banner-half/banner-half'
import animatedSlide from './components/custom/organisms/animated-slide/animated-slide'
import productDetails from './components/custom/organisms/product-details/product-details'
import editorialSlider from './components/custom/organisms/editorial-slider/editorial-slider'
import shopByLook from './components/custom/organisms/shop-by-look'
// .Templates
import sortByTemplate from './components/custom/templates/sortby-template'
import localeModal from './components/custom/templates/locale-modal'
import newsletterModal from './components/custom/templates/newsletter-modal/newsletter-modal'
import switchLocaleModal from './components/custom/templates/switch-locale-modal'
import minicartBody from './components/custom/templates/minicart-body'
import minicartFooter from './components/custom/templates/minicart-footer'
import productTileCart from './components/custom/templates/product-tile-cart'
import wishlistSizeModal from './components/custom/templates/wishlist-size-modal'
import loginDrawer from './components/custom/templates/login-drawer'
import shopTheImage from './components/custom/templates/shop-the-image'
import resetPasswordDrawer from './components/custom/templates/reset-password'
import newsletterModalSmall from './components/custom/templates/newsletter-modal-small'
// .Pages
import productList from './components/custom/pages/product-list'
import errorPage from './components/custom/pages/error-page'
import wishlistPage from './components/custom/pages/wishlist'
import homePage from './components/custom/pages/home-page'
import productDetailsPage from './components/custom/pages/product-details-page'

export const cucinelliTheme = {
    // Global styles
    styles: {
        global: {
            ...globalStyles,
            ...Swiper,
            ...SwiperNavigation,
            ...SwiperScrollbar,
            ...SwiperPagination,
        },
    },
    // Foundations
    ...themeBreakpoints,
    ...textStyles,
    ...themeFonts,
    ...themeColors,
    ...themeSpacing,
    ...borderRadius,
    // Sizes
    sizes: {
        ...themeSizes,
        ...container.sizes,
    },
    components: {
        // Chakra components
        ...buttons,
        ...container,
        ...breadcrumb,
        ...form,
        ...input,
        ...select,
        ...radio,
        ...tag,
        ...checkbox,
        ...accordion,
        ...drawer,
        ...modal,
        ...link,
        ...popover,
        // Custom components
        // .Atoms
        ...chips,
        ...loader,
        ...menuButton,
        ...price,
        ...darkOverlay,
        ...spacer,
        ...colorCirle,
        // .Molecules
        ...newsletterInput,
        ...headerLink,
        ...menuItem,
        ...headline,
        ...filterButton,
        ...sortByWrapper,
        ...bannerHeader,
        ...cardPhotoVideo,
        ...productTile,
        ...gridLayoutControls,
        ...pagination,
        ...tabs,
        ...toast,
        ...quantitySelector,
        ...alertMessage,
        ...crossCategoryNavigation,
        ...ctaButton,
        ...scrollDownButton,
        // .Organisms
        ...productsSwiper,
        ...footer,
        ...heroBanner,
        ...header,
        ...doubleSame,
        ...refinementsGroup,
        ...productListing,
        ...twoThirdOneThird,
        ...filtersList,
        ...selectedRefinements,
        ...wishlistOrganism,
        ...stickyBanner,
        ...editorialWidget,
        ...wallMixed,
        ...mouseover,
        ...titleTextCta,
        ...bannerHalf,
        ...animatedSlide,
        ...productDetails,
        ...editorialSlider,
        ...shopByLook,
        // .Templates
        ...sortByTemplate,
        ...localeModal,
        ...switchLocaleModal,
        ...minicartBody,
        ...minicartFooter,
        ...productTileCart,
        ...newsletterModal,
        ...wishlistSizeModal,
        ...loginDrawer,
        ...shopTheImage,
        ...resetPasswordDrawer,
        ...newsletterModalSmall,
        // .Pages
        ...productList,
        ...errorPage,
        ...wishlistPage,
        ...homePage,
        ...productDetailsPage,
    },
}

export default extendTheme(cucinelliTheme)
